import React, {
	memo,
} from 'react';
import { useSelector } from 'react-redux';
import { GreenroomState as GS } from '../../stores/types/types';
import Spotlight from './spotlight';
import { connectorIdLive } from './spotlight-utils';
import useShotMemos from '../../hooks/use-shot-memos';
import type { ShotFeed } from '../../stores/types/shots';
import useCanvasConfig from '../../hooks/use-canvas-config';

interface FeedsType {
     [key: string]: {[key: string]: {position: number, audioOnly: boolean}}
}

const Spotlights = () => {
	const currentShotId = useSelector((state: GS) => state.ShotsReducer.currentShotId);
	const clearShot = useSelector((state: GS) => state.SettingsReducer.clearShot);
	const feeds : FeedsType = {};

	const { currentShot, nextShot } = useShotMemos();

	const nextShotId = nextShot?.shot_id ?? -1;

	const { shotFeeds } = useCanvasConfig(currentShot);
	const { shotFeeds: nextShotFeeds } = useCanvasConfig(nextShot);

	const hydrateShots = (feed: ShotFeed, shotId: number) => {
		switch (feed.feedType) {
			case 'presenter':
				feeds[feed.presenter!] = {
					...feeds[feed.presenter!],
					[shotId]: { position: feed.position, audioOnly: feed.audioOnly },
				};
				break;
			case 'screenshare':
				feeds[feed.screenshare!] = {
					...feeds[feed.screenshare!],
					[shotId]: { position: feed.position, audioOnly: feed.audioOnly },
				};
				break;
			case 'audio':
			case 'media':
				feeds[feed.media!] = {
					...feeds[feed.media!],
					[shotId]: { position: feed.position, audioOnly: feed.audioOnly },
				};
				break;
			case 'sipCall':
				feeds[feed.sipStreamId!] = {
					...feeds[feed.sipStreamId!],
					[shotId]: { position: feed.position, audioOnly: feed.audioOnly },
				};
				break;
			case 'srtStream':
				feeds[feed.srtStreamId!] = {
					...feeds[feed.srtStreamId!],
					[shotId]: { position: feed.position, audioOnly: feed.audioOnly },
				};
				break;
			case 'onsiteLocation':
				feeds[feed.onsiteLocationId!] = {
					...feeds[feed.onsiteLocationId!],
					[shotId]: { position: feed.position, audioOnly: feed.audioOnly },
				};
				break;
			default:
				break;
		}
	};

	shotFeeds.forEach((feed) => {
		hydrateShots(feed, currentShotId);
	});
	nextShotFeeds.forEach((feed: ShotFeed) => {
		hydrateShots(feed, nextShotId);
	});

	const mediaSpotlights = Object.keys(feeds).map((key) => {
		const spotlightId = `spotlight-${connectorIdLive(key, 1)}`;
		const { position, audioOnly } = feeds[key][currentShotId]
			? feeds[key][currentShotId] : feeds[key][nextShotId];

		return <Spotlight
			key={key}
			position={`feed-${position}`}
			nextShot={!feeds[key][currentShotId]}
			isAudioOnly={audioOnly}
			spotlightId={spotlightId}
			mediaId={key}
		/>;
	});

	return <div>{!clearShot && mediaSpotlights}</div>;
};

export default memo(Spotlights);
